export enum EBasicColors {
    BLACK,
    CMYK,
    CMYK_SPECIAL_COLORS
}